import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { filter, skip } from 'rxjs';
import { opacityInOut } from '../../animations/opacity-in-out.animation';

@Component({
  selector: 'a-input',
  templateUrl: 'a-input.component.html',
  styleUrls: ['a-input.component.scss'],
  animations: [ opacityInOut ]
})
export class AInputComponent implements OnInit {

  @Input() type = 'text';
  @Input() isSubmitted = true;
  @Input() errorMessage = null;
  @Input() tooltipMessage = null;
  @Input() label = '';
  @Input() grayBg = true;
  @Input() isOptional = false;
  @Input() isSearch = false;
  @Input() isDisabled = false;
  @Input() icon = null;
  @Input() maxLength: number | null = null;
  @Input() control: any = new FormControl();
  @Input() set isIncognito(val) {
    if (this.isAnonymous === null) {
      this.isAnonymous = val
    } else {
      val ? setTimeout(() => this.isAnonymous = val, 1000) : this.isAnonymous = val;
    }
  };
  @Output() onBlur = new EventEmitter<any>();
  initValue = null;
  isAnonymous = null;

  constructor() {
  }

  ngOnInit(): void {
    if (this.control.value) {
      this.initValue = this.control.value;
    }
  }

  handleInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    let value = inputElement.value;

    if (this.type === 'tel' || this.type === 'number') {
      value = value.replace(/[^0-9+]+/g, '');
      if (inputElement.value !== value) {
        inputElement.value = value;
        this.control.setValue(value);
      }
    }
  }

  checkSave() {
    if (this.control.value !== this.initValue) {
      this.onBlur.emit();
      this.isSubmitted = true;
      this.initValue = this.control.value;
    }
  }

  clear() {
    this.control.reset();
  }

}
